const sans = "Lato";
const serif = "New Spirit";
const serifCondensed = "New Spirit Condensed";

/** family names as registered by the @font-face rules in `src/styles/fonts.css` — the only other place they appear */
export const fontFamily = {
  sans,
  serif,
  serifCondensed,
  serifFallback: `${serif} Fallback`,
  serifCondensedFallback: `${serifCondensed} Fallback`,
} as const;

export const fonts = {
  /* full stacks — components never write a font-family of their own, they use a `theme.type.*` role (or, for the rare
     exception, one of these) */
  font: {
    primary: `"${sans}", sans-serif`,
    heading: `"${serif}", "${fontFamily.serifFallback}", "Times New Roman", serif`,
    display: `"${serifCondensed}", "${fontFamily.serifCondensedFallback}", "Times New Roman", serif`,
  },
  /* legacy scale: text takes a `theme.type` role; these remain for non-text sizing (icon boxes, cqw clamp fallbacks
     in cards) and the parts not migrated yet (navbar, loyalty) */
  fontSize: {
    xxs: "0.65rem",
    xs: "0.75rem",
    base: "0.85rem",
    lg: "1rem",
    xl: "1.2rem",
    xxl: "1.4rem",
    "2xl": "1.6rem",
    "3xl": "1.8rem",
    "4xl": "2rem",
    "5xl": "2.5rem",
    "6xl": "4rem",
  },
  /* legacy Lato-era tracking, only the navbar and the loyalty pages still read it; the roles carry their own tracking */
  letterSpacing: {
    none: "0",
    sm: "1px",
    md: "2px",
    lg: "3px",
  },
  /* Lato ships 300 (section kickers only) / 400 / 700; `thin` is also the serif's Condensed Light. `light` = 400 alias */
  fontWeight: {
    thin: "300",
    light: "400",
    normal: "400",
    extraBold: "700",
  },
};
